module.exports = __webpack_public_path__ + "static/img/post_brid.5a625de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/post_brid.png
// module id = f8Ys
// module chunks = 1 3